<template>
	<div class="header flex" @click="showMsg=false">
		<span class="logo" @click.stop="setLeftMenu">
			<i class="iconfont">&#xe608;</i>
		</span>
		<ul class="menu flex">
      <!-- @click.stop="tabMenu(item.resourceId)" -->
			<li class="item" v-for="(item,index) of topMenu" @click.stop="topMenuTab(item.resourceId)"  :key="index" :class="{active:topMenuIndex == item.resourceId}">
				<router-link v-if="item.resourceHref==='/'" exact class="txt" :to="{path:item.resourceHref}" :id="item.id">{{item.resourceName}}</router-link>
				<router-link v-else class="txt" :to="{path:item.resourceHref}" :id="item.id">{{item.resourceName}}</router-link>
			</li>
		</ul>
    <el-dropdown class="right_user" trigger="click">
      <div class="el-dropdown-link user-cons flex-nowrap">
        <span class="header_img" title="用户头像"></span>
        <div class="uname">
          <p class="nickname">{{userInfo.name ? userInfo.name : userInfo.account}}</p>
          <!-- <p class="card">管理员</p> -->
        </div>
      </div>
      <el-dropdown-menu slot="dropdown" class="right_user_menu">
        <el-dropdown-item @click.native="modifyPwd" class="modify-pwd"><i class="iconfont">&#xe628;</i> 修改密码</el-dropdown-item>
        <el-dropdown-item @click.native="loginOut"><i class="iconfont">&#xe61d;</i>注销</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>


<!-- 修改密码 -->
<el-dialog title="修改密码" customClass="w500" :visible.sync="dialogFormVisible" :modal-append-to-body='false' v-dialogDrag>
  <el-form :model="fromData" ref="subForm" label-width="80px" :rules="rules">
    <p class="info" style="text-align:center;padding-bottom:20px;">当前账号：{{userInfo.account}}</p>
    <el-form-item label="原密码" prop="oriPassword">
      <el-input placeholder="请输入原始密码" v-model="fromData.oriPassword" show-password clearable></el-input>
    </el-form-item>
    <el-form-item label="新密码" prop="adjustPassword">
      <el-input placeholder="请输入新密码" v-model="fromData.adjustPassword" show-password clearable></el-input>
    </el-form-item>
    <el-form-item label="确认密码"prop="confirmPassword">
      <el-input placeholder="请再输入新密码" v-model="fromData.confirmPassword" show-password clearable></el-input>
    </el-form-item>
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="submitForm">确 定</el-button>
  </div>
</el-dialog>

<!-- <div class="message_info success">
    <i class="iconfont">&#xe62a;</i>
    <div class="cons_txt">
      <p class="title">操作成功</p>
      <p class="remark_txt">其他文字</p>
    </div>
</div>
<div class="message_info error">
    <i class="iconfont">&#xe646;</i>
    <div class="cons_txt">
      <p class="title">操作失败</p>
      <p class="remark_txt">其他文字其他文字其他文字其他文字其他文字其他文字其他文字其他文字其他文字其他文字其他文字其他文字其他文字其他文字其他文字</p>
    </div>
</div>
 -->
</div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import account from 'api/account.js';
export default{
  name:"common-header",
  props:{
    topMenuIndex:Number,
    topMenu:Array,
    userInfo:Object
  },
  data(){
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.fromData.adjustPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return{
      dialogFormVisible:false,
      editDialogFormVisible:false,
      msgNum:999,
      showMsg:false,
      isLeftMenu:false,
      fromData:{},
      rules:{
        oriPassword: [
          {required: true,message: '请输入原密码',trigger: 'blur'},
          {min:5, max: 20, message: '密码长度在 5 - 20位字符',trigger: 'blur' }
        ],
        adjustPassword:[
          {required: true,message: '请输入新密码',trigger: 'blur'},
          {min:5, max: 20, message: '密码长度在 5 - 20位字符',trigger: 'blur' }
        ],
        confirmPassword:[
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      },
    }
  },
	created(){
  },
  updated(){

  },
  watch:{
    "$route":{
      handler:function(to, from){
        //this.getMenuIndex();
      },
      // 深度观察监听
      deep: true
    }
  },
	computed:{
		getMsgNum: function(){
			//超过99时显示99+
			return this.msgNum > 99 ? '99+' : this.msgNum;
		}
	},
	methods:{
    ...mapActions('account',["logout","topMenuTab"]),
    ...mapActions('pages',['closeAll']),
    /**
     * @description 登出
     */
    loginOut () {
      this.logout({
        confirm: true
      });
      //关闭所有已打开的面板
      //this.closeAll();
    },
    //修改密码
    modifyPwd(){
      this.dialogFormVisible = true;
      //modifyPwd
    },
    //设置左侧菜单显示/隐藏
    setLeftMenu(){
      this.isLeftMenu = !this.isLeftMenu;
      if(this.isLeftMenu){
        $('.main_left').width(0);
        $('.right_main').css('left',0);
      }else{
        $('.main_left').width(200);
        $('.right_main').css('left',200);
      }
    },
    //提交
    submitForm(){
      //console.log(this.fromData);
      let vm = this;
      this.$refs['subForm'].validate(async (vaild)=>{
        if(!vaild) return;
        //console.log(JSON.stringify(this.fromData),'提交的数据');
        this.fromData.account = this.userInfo.account;
        this.fromData.userId = this.userInfo.userId;
        if(this.fromData.oriPassword === this.fromData.adjustPassword){
          this.$message.error("原密码和新密码不能一样");
          return;
        }
        let res = await this.$post(account.modifyPwd,this.fromData);
        if(res.status){//修改成功
          this.dialogFormVisible = false;
          this.$alert('修改成功，请重新登录', '操作提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.logout({
                confirm: false
              });
            }
          });
        }else{//失败
          this.$message.error(res.errorMsg);
        }
      });
      //dialogFormVisible = false
    }
	}
}
</script>
